import SiteHeader from "./components/SiteHeader";
import HeroSection from "./components/HeroSection";
import UpdateTimeline from "./components/UpdateTimeline";
import ReminderPanel from "./components/ReminderPanel";
import CheckinCalendar from "./components/CheckinCalendar";
import FlashFeed from "./components/FlashFeed";
import CommentSection from "./components/CommentSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <UpdateTimeline />
        <ReminderPanel />
        <CheckinCalendar />
        <FlashFeed />
        <CommentSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}